interface RatingScaleProps {
  value: number | null;
  onChange: (value: number) => void;
  scale?: number;
  label?: string;
  lowLabel?: string;
  highLabel?: string;
}

export default function RatingScale({
  value,
  onChange,
  scale = 5,
  label,
  lowLabel,
  highLabel,
}: RatingScaleProps) {
  const steps = Array.from({ length: scale }, (_, i) => i + 1);

  return (
    <div className="space-y-3">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <div className="inline-flex flex-col gap-1">
        <div className="flex gap-2 flex-wrap">
          {steps.map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => onChange(n)}
              className={`w-11 h-11 rounded-full border text-sm font-semibold transition-colors ${
                value === n
                  ? "border-electrum-300 bg-electrum-300 text-white"
                  : "border-gray-300 bg-white text-gray-600 hover:border-electrum-300 hover:text-electrum-300"
              }`}
            >
              {n}
            </button>
          ))}
        </div>
        {(lowLabel || highLabel) && (
          <div className="flex justify-between text-xs text-gray-400 px-1">
            <span>{lowLabel}</span>
            <span>{highLabel}</span>
          </div>
        )}
      </div>
    </div>
  );
}
